import React from 'react';
import { Text } from '@chakra-ui/react';
import { Link } from 'components/shared/Link';
import { useScrollToAnchor } from 'hooks/useScrollToAnchor';

export const Remark = React.memo(() => {
  const scrollToAnchor = useScrollToAnchor();

  return (
    <Text fontSize={{ base: 11, sm: 12, md: 14, lg: 16 }} mt={4} mb={2}>
      *合資格會員即獲贈：德國寶人氣家電預購e券(1日期)1張^，憑券即日可以會員價預購指定家電。
      <br />
      ^每張預購e券只限預購家電1件，如欲預購多件，須於另一交易（消費滿$200或兌換200積分）後，獲贈e券預購。
      <br />
      #交易後會員必需填妥電子送貨表格（詳情請參閱 –{' '}
      <Link
        href="#送貨須知"
        onClick={scrollToAnchor('送貨須知')}
        color="blue.500"
        _focus={{ border: 'none' }}
      >
        送貨須知
      </Link>
      )。
      <br />
      數量有限，換完即止
      <br />
    </Text>
  );
});
